<template>
  <div class="container">
      <QueryFrame
        @handlePage='handlePage'
        @handlePageSize='handlePageSize'
        :disablePage='disablePage'
        :current='page'
        :count='count'>
        <div slot="queryParams" class="form">
          <div class="queryContainer">
            <div class="queryItem">
              <label>创建时间:</label>
                <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model.trim='query.duration' />
            </div>
            <div class="queryItem">
              <label>来源:</label>
              <lk-select class="item" clearable v-model.trim='query.source'>
                <lk-option v-for="(item,index) in sourceList" :key="index" :value='item'>
                  {{item}}
                </lk-option>
              </lk-select>
            </div>
            <div class="queryItem">
              <label>处方单号:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.code'></lk-input>
            </div>
            <div class="queryItem">
              <label>销售订单号:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.orderCode'></lk-input>
            </div>
            <div class="queryItem">
              <label>患者姓名:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.patientName'></lk-input>
            </div>
            <div class="queryItem">
              <label>患者联系方式:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.patientPhone' />
            </div>
            <div class="queryItem">
              <label>处方医生:</label>
              <lk-input :maxlength='100' class="item" placeholder='请输入' clearable v-model.trim='query.doctor' />
            </div>
            <div class="queryItem">
              <label>商保支付状态:</label>
              <lk-select class="item" clearable v-model.trim='query.paymentStatus'>
                <lk-option v-for="(item) in paymentStatusList" :key="item.value" :value='item.value'>
                  {{item.name}}
                </lk-option>
              </lk-select>
            </div>
            <div class="queryItem">
              <label>订单状态:</label>
              <lk-select class="item" clearable v-model.trim='query.status'>
                <lk-option v-for="(item,index) in statusList" :key="index" :value='item.id'>
                  {{item.name}}
                </lk-option>
              </lk-select>
            </div>
             <div class="queryItem">
              <label>三方订单号:</label>
              <lk-input :maxlength='50' placeholder='请输入' class="item" clearable v-model.trim='query.onlineOrderCode'/>
            </div>
            <div class="queryItem"  v-if="roleType!==2">
              <label>门店名称:</label>
              <StoreListSelect class="item" clearable v-model.trim='query.storeIdList'></StoreListSelect>
            </div>
            <div class="queryItem">
              <label>联系人:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.contact'/>
            </div>
            <div class="queryItem">
              <label>小程序订单号:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.appletOrderCode'/>
            </div>
            <div class="queryItem">
              <label>商保类型:</label>
              <lk-select class="item" clearable v-model.trim='query.commercialTypeList' :multiple="true">
                <lk-option v-for="item in commercialTypeLists" :key="item.id" :value='item.id'>
                  {{item.name}}
                </lk-option>
              </lk-select>
            </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
        </div>
        <div slot="table">
          <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('epDownload')"></DownloadButton>
            <lk-table border :columns='columns' :data='tableData'></lk-table>
        </div>
      </QueryFrame>
      <!-- 小程序预约单取消预约弹窗 -->
      <CancelOrderModal
        v-model="cancelModal"
        :cancelOrderParams="cancelOrderParams"
        @getData='getData'
      ></CancelOrderModal>
      <BarcodeModal
        v-if="barcodeData.orderNo"
        v-model='showBarcode'
        :barcodeData='barcodeData'
        ref="barcodeModal"
      ></BarcodeModal>
      <DTPModal
        v-model='unionDrugOnlineNotice'
        content='请确认已完成今日顺丰冷链包材盘点，否则可能导致运单下单失败'
        @confirm='handlerGoPage'
        :noCancel='true'
        confirmText='知道了'
      ></DTPModal>
      <lk-modal
        v-model="checkOrderModal.isShow"
        title="审核订单"
        @on-ok="toCheck"
      >
        <div style="display:flex;align-items:center;justify-content:center;">
          <div>审核结果：</div>
          <div>
            <lk-select v-model="checkOrderModal.checkResult" style="width:200px;">
              <lk-option v-for="item in checkOrderModal.checkList" :key="item.id" :value='item.id'>
                {{item.name}}
              </lk-option>
            </lk-select>
          </div>
        </div>
      </lk-modal>
  </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import sale from '@/services/sale';
import utils from '@/libs/utils';
import mapState from '@/mixins/mapState'; // 鉴权
import cnPrint from '@/libs/cainiaoPrint';
import queryMixins from '@/mixins/queryMixins';
import DownloadButton from '@/components/download/DownloadButton';
import CancelOrderModal from '@/components/prescription/CancelOrderModal.vue';
import BarcodeModal from '../../components/BarcodeModal';
import DTPModal from '../../components/DTPModal.vue';

export default {
  name: 'prescriptionList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    CancelOrderModal,
    BarcodeModal,
    DTPModal,
  },
  data() {
    return {
      checkOrderModal: {
        isShow: false,
        checkResult: '01', // 审核结果
        orderId: '', // 镁信订单号
        checkList: [
          {
            id: '01',
            name: '审核通过'
          },
          {
            id: '02',
            name: '审核不通过'
          },
        ] 
      },
      commercialTypeLists: [
        {
          id: 1,
          name: '21免疫优仙_93'
        },
        {
          id: 2,
          name: '22心优选_93'
        },
        {
          id: 3,
          name: '22心优选_95'
        },
        {
          id: 4,
          name: '21e路相伴_91'
        },
        {
          id: 5,
          name: '22e路相伴_91'
        },
        {
          id: 6,
          name: '22e路相伴_93'
        },
      ],
      unionDrugOnlineNotice: false,
      goPageconfig: {
        params: {},
        query: {},
      },
      showBarcode: false,
      barcodeData: {},
      cancelModal: false, // 预约弹窗
      loading: false,
      socket: '',
      printData: '', // 打印信息
      sourceList: [],
      paymentStatusList: [{
        value: 1,
        name: '未支付',
      }, {
        value: 2,
        name: '已支付',
      }],
      statusList: [
        {
          id: 7,
          name: '待审核',
        },
        {
          id: 1,
          name: '待出库',
        },
        {
          id: 3,
          name: '已出库',
        },
        {
          id: 11,
          name: '退款审核中',
        },
        {
          id: 5,
          name: '已驳回',
        },
        {
          id: 6,
          name: '已取消',
        },
        {
          id: 2,
          name: '已失效',
        },
        {
          id: 8,
          name: '未生效',
        },
      ],
      query: {
        duration: [],
        source: null,
        code: null,
        contact: null,
        patientName: null,
        patientPhone: null,
        doctor: null,
        status: null,
        orderCode: null,
        commercialTypeList: [],
      },
      columns: [
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '来源', key: 'source', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '商保支付状态', key: 'paymentStatusName', minWidth: 116 },
        { title: '商保支付金额', key: 'proceedsAmount', minWidth: 116 },
        { title: '订单状态', key: 'statusName', minWidth: 116 },
        { title: '患者姓名', key: 'patientName', minWidth: 116 },
        { title: '患者年龄', key: 'patientAge', minWidth: 116 },
        { title: '患者性别', key: 'patientGenderString', minWidth: 116 },
        { title: '患者联系方式', key: 'patientPhone', minWidth: 116 },
        { title: '处方单号', key: 'code', minWidth: 116 },
        { title: '医院', key: 'hospital', minWidth: 116 },
        { title: '处方医生', key: 'doctor', minWidth: 116 },
        { title: '销售订单号', key: 'orderCode', minWidth: 116 },
        { title: '开方日期', key: 'prescriptionSignTime', minWidth: 116 },
        { title: '审方药剂师', key: 'auditPharmacistName', minWidth: 116 },
        { title: '驳回原因', key: 'prescriptionRejectionReasonName', minWidth: 116 },
        { title: '物流状态', key: 'receivedStatusName', minWidth: 116 },
        { title: 'ID类型', key: 'creatorTypeName', minWidth: 116 },
        { title: 'ID', key: 'creatorId', minWidth: 116 },
        { title: '来源姓名', key: 'creator', minWidth: 116 },
        { title: '三方订单号', key: 'onlineOrderCode', minWidth: 116 },
        { title: '商保类型', key: 'commercialTypeName', minWidth: 116 },
        { title: '小程序订单号', key: 'appletOrderCode', minWidth: 116 },
        { title: '取消原因', key: 'cancelReasonName', minWidth: 116 },
        { title: '联系人', key: 'contact', minWidth: 116 },
        { title: '备注', key: 'remark', minWidth: 116 },

        {
          title: '操作',
          key: 'action',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            const edit = this.handlePermission('prescriptionEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'prescriptionEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null;
            const check = this.handlePermission('prescriptionCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'prescriptionCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null;
            const audit = this.handlePermission('prescriptionAudit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'prescriptionAudit', params: { id: params.row.id } });
                },
              },
            }, '去审核') : null;
            const create = this.handlePermission('prescriptionSale') && params.row.isGoodsBaseOnly === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const param = {
                    id: params.row.id,
                  };

                  this.goPageconfig = {
                    params: param,
                  };
                  if (params.row.unionDrugOnlineNotice === 1) {
                    this.unionDrugOnlineNotice = true;
                  } else {
                    // 带两个参数，isPC线下订单，online线上订单在药学服务范围内的
                    this.$router.push({ name: 'prescriptionSale', params: param });
                  }
                },
              },
            }, '创建销售订单') : null;
            const orderCheck = this.handlePermission('salesOrderCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'salesOrderCheck', params: { id: params.row.orderId }, query: { isCheck: 1 } });
                },
              },
            }, '查看销售订单') : null;
            // 小程序预约取消预约按钮
            const cancel = this.handlePermission('prescriptionCancel') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.cancelModal = true;
                  const { id, appId, createTime } = params.row;
                  const time = new Date(createTime).getTime();
                  if (new Date().getTime() - time > 1000 * 60 * 60 * 24 * 365) {
                    this.$Message.warning('交易时间超过一年的订单无法微信原路退款，请联系患者进行线下退款。');
                  }
                  this.cancelOrderParams = {
                    epId: id,
                    appId,
                  };
                },
              },
            }, '取消预约') : '';
            // 菜鸟打印
            const cainiaoPrint = this.handlePermission('cainiaoPrint') && params.row.sourceType != 13 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  // 打印
                  this.loading = true;
                  this.handlerPrint(params.row.id);
                },
              },
            }, '打印面单') : '';
            const auditOrder = this.handlePermission('orderAudit') ? h('lk-button', { // 镁信来源增加审核订单按钮
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.checkOrderModal.isShow = true;
                  this.checkOrderModal.orderId = params.row.onlineOrderCode;
                  this.checkOrderModal.checkResult = '01';
                },
              },
            }, '审核订单') : '';
            if (params.row.status === 3) {
              if ([10, 13].indexOf(params.row.sourceType) >= 0) {
                return h('div', [check, orderCheck, cainiaoPrint]);
              }
              return h('div', [check, orderCheck]);
            }
            if (params.row.status === 5 || params.row.status === 2 || params.row.status === 6 || params.row.status === 8 || params.row.status === 11) {
              return h('div', [check]);
            }
            if (params.row.status === 9 || params.row.status === 10) {
              return h('div', [check, cancel]);
            }
            if (params.row.sourceType === 2 || params.row.sourceType === 5 || params.row.sourceType === 8) {
              if (params.row.status === 1) {
                return h('div', [edit, create, cancel]);
              }
              if (params.row.status === 7) {
                return h('div', [audit, edit, cancel]);
              }
            } else {
              if (params.row.status === 1) {
                if (params.row.sourceType == 0 || params.row.sourceType === undefined) { // 处方笺-线下药学服务处方笺，审核通过后不可再编辑
                  return h('div', [create]);
                }
                return h('div', [edit, create]);
              }
              if (params.row.status === 7) {
                if ([12].includes(params.row.sourceType)) { // 镁信来源 12
                  return h('div', [auditOrder, edit]);
                }
                return h('div', [audit, edit]);
              }
            }
          },
        },
      ],
      tableData: [],
      // page: 1,
      // size: 10,
      count: 0,
      localtion: [],
      kmCode: '',
      cancelOrderParams: { // 取消预约入参
        epId: null,
        appId: null,
      },
    };
  },
  methods: {
    toCheck() {
      const { checkResult, orderId } = this.checkOrderModal;
      const params = {
        orderStatus: checkResult,
        mxOrderNo: orderId,
      }
      sale.checkOrder(params).then(res => {
        if (res.data.status === 200) {
          this.$Message.success('操作成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    handlerGoPage() {
      this.unionDrugOnlineNotice = false;
      const {
        params,
      } = this.goPageconfig;
      this.$router.push({ name: 'prescriptionSale', params });
    },
    handlerPrint(epId) {
      cnPrint.getPrintData(epId, (res) => {
        if (res.status == 'failed') {
          this.$Message.error(res.msg);
          return;
        }
        if (res.status === 'success' && res.cmd === 'print') {
          this.$Message.success('已加入打印队列，请等待');
        }
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.$Modal.error({
          title: '温馨提示',
          content: `<p>${err}</p>`
        })
      });
    },
    download() {
      const params = utils.deepClone(this.params);
      params.page = 0;
      params.size = 0;

      params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      delete params.duration;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      params.type = 1;
      params.typeList = [1, 3, 5];
      sale.getPrescriptionListDownload(params).then((res) => {
        // utils.downLoadExcel(res, '处方药销售记录查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    testKmCode() {

    },
    clear() {
      this.query = {
        duration: [],
        source: null,
        code: null,
        patientName: null,
        patientPhone: null,
        doctor: null,
        status: null,
        contact: null,
        orderCode: null,
        commercialTypeList: [],
      };
    },
    getlocaltions() {

    },
    loadLocaltion() {

    },
    // handleSearch() {
    //   this.params = Object.assign(this.params, this.query);
    //   this.handlePage(1, true);
    // },
    getSourceList() {
      sale.getSourceList({ typeList: [1, 3, 5] }).then((res) => {
        if (res.data.status === 200) {
          this.sourceList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      this.params.duration && ([this.params.createTimeStart, this.params.createTimeEnd] = this.params.duration);
      delete this.params.duration;
      this.params.typeList = [1, 3, 5];
      sale.getPrescriptionList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = utils.deepClone(item.ep);
            result.unionDrugOnlineNotice = item.unionDrugOnlineNotice;
            result.prescriptionRejectionReasonName = item.prescriptionRejectionReasonName;
            result.proceedsAmount = item.proceedsAmount;
            result.isGoodsBaseOnly = item.isGoodsBaseOnly;
            result.orderStatusName = item.orderStatusName;
            result.visiblePrescriptionAudit = item.visiblePrescriptionAudit;
            result.receivedStatusName = item.receivedStatusName;
            result.createTime = utils.formatTime(result.createTime);
            result.prescriptionSignTime = utils.formatDate(result.prescriptionSignTime);
            result.patientGenderString = this.publicParams.genderList[result.patientGender];
            // result.paymentStatusString = this.publicParams.judgeList[result.paymentStatus];
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    addNew() {
      this.$router.push({ name: 'supplierGeneralAdd' });
    },
    handlerRouteParams() {
      if (this.$route.params) {
        const {
          id,
          orderNo,
          tag,
          proceedsStatus,
        } = this.$route.params;
        if (tag === 2 && proceedsStatus !== 1) {
          this.barcodeData = {
            id,
            orderNo,
          };
          this.showBarcode = true;
        }
      }
    },
  },
  mounted() {
    this.getSourceList();
    this.handleSearch(true);
    this.handlerRouteParams();
  },
};
</script>

<style lang="less" scoped>
</style>
